import { createContext, useEffect, useMemo, useState } from 'react'
import { useAuth } from '../authContext/utils'
import { getOrgConfigById } from '../../constants/orgConfig'
import type { IOrgConfig } from '../../constants/orgConfig'

type IOrgConfigContextType = IOrgConfig

export const OrgConfigContext = createContext<IOrgConfig | undefined>(undefined)

export const OrgConfigProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [orgConfig, setOrgConfig] = useState<IOrgConfig | undefined>(undefined)
  const { orgId } = useAuth()

  useEffect(() => {
    if (orgId) {
      const orgConfig = getOrgConfigById(orgId)
      setOrgConfig(orgConfig)
    } else {
      setOrgConfig(undefined)
    }
  }, [orgId])

  const contextValue: IOrgConfigContextType = useMemo(() => {
    return {
      orgName: orgConfig?.orgName ?? null,
      orgId: orgConfig?.orgId ?? null,
      dataSourceGUID: orgConfig?.dataSourceGUID ?? null,
    }
  }, [orgConfig])

  return <OrgConfigContext.Provider value={contextValue}>{children}</OrgConfigContext.Provider>
}

export type { IOrgConfigContextType }